import {useCoursesStore} from "../../stores/courses";
import {useRoute} from 'ui.vue3.router';
import {computed} from "ui.vue3";

export const CourseDetail = {
    setup() {
        const route = useRoute();
        const courseStore = useCoursesStore();
        courseStore.courseCode = route.params.course;
        courseStore.courseGroup = route.params.category;
        courseStore.fetchCourseDetail();

        const detail = computed(() => courseStore.detail)

        return { detail }
    },
    template: `
        <div class="content-detail"> 
            <h1>{{detail.NAME}}</h1>
            <p class="alert alert-success">Уровень: {{detail.LEVEL_NAME}} / {{detail.GROUP_NAME}}</p>
            <p class="alert alert-info">{{detail.TEXT_MAIN}}</p>
            <p class="alert alert-danger">Цена: {{detail.PRICE}} р.</p>
        </div>
    `
}